<aside class="sidebar" [class.mobile-open]="isCollapsed">

  <div class="sidebar-top">
    <div class="brand-row" (click)="toggleSidebar()" role="button" tabindex="0" (keyup.enter)="toggleSidebar()">
      <img src="assets/logo2.png" alt="KreddyPay Logo" class="brand-logo"
        style="height:48px; width:auto; border-radius:8px; margin-left: 10px;" />
    
    </div>
    <div class="mobile-user-info" *ngIf="isCollapsed">
      <div class="user-avatar">{{ userInitials }}</div>
      <div>
        <div class="user-name-mobile">{{ userEmail }}</div>
        <div class="user-role-mobile">{{userRole | titlecase}}</div>
      </div>
    </div>
    <hr class="brand-divider">
    <nav class="sidebar-nav">
      <!-- Dashboard - visible to all -->
      <a class="nav-item" routerLink="/dashboard" routerLinkActive="active" [title]="'Dashboard'"
        (click)="isCollapsed = false">
        <i data-lucide="layout-dashboard" class="nav-icon"></i>
        <span>Dashboard</span>
      </a>

      <!-- Admin/Super Admin and Staff -->
      <a *ngIf="isAdmin() || isStaff()" class="nav-item" routerLink="/distributors" routerLinkActive="active"
        [title]="'Distributors'" (click)="isCollapsed = false">
        <i data-lucide="users" class="nav-icon"></i>
        <span>Distributors</span>
      </a>

      <!-- Admin/Super Admin, Distributor, and Staff -->
      <a *ngIf="isAdmin() || isDistributor() || isStaff()" class="nav-item" routerLink="/retailers"
        routerLinkActive="active" [title]="'Retailers'" (click)="isCollapsed = false">
        <i data-lucide="store" class="nav-icon"></i>
        <span>Retailers</span>
      </a>

      <!-- Admin/Super Admin only -->
      <a *ngIf="isAdmin()" class="nav-item" routerLink="/staff" routerLinkActive="active" [title]="'Staff'"
        (click)="isCollapsed = false">
        <i data-lucide="user" class="nav-icon"></i>
        <span>Staff</span>
      </a>

      <!-- Admin/Super Admin and Distributor -->
      <a *ngIf="isAdmin() || isDistributor()" class="nav-item" routerLink="/invoices" routerLinkActive="active"
        [title]="'Invoices'" (click)="isCollapsed = false">
        <i data-lucide="file-text" class="nav-icon"></i>
        <span>Invoices</span>
      </a>

      <!-- Admin/Super Admin only -->
      <a *ngIf="isAdmin()" class="nav-item" routerLink="/transactions" routerLinkActive="active"
        [title]="'Transactions'" (click)="isCollapsed = false">
        <i data-lucide="credit-card" class="nav-icon"></i>
        <span>Transactions</span>
      </a>

      <!-- Admin/Super Admin only -->
      <a *ngIf="isAdmin()" class="nav-item" routerLink="/purchase-limits" routerLinkActive="active"
        [title]="'Purchase Limits'" (click)="isCollapsed = false">
        <i data-lucide="wallet" class="nav-icon"></i>
        <span>Purchase Limits</span>
      </a>
    </nav>
  </div>

  <div class="sidebar-bottom">
    <div class="sidebar-user" (click)="toggleUserMenu()">
      <div class="user-avatar">{{ userInitials }}</div>
      <div>
        <div class="user-name initials-only">{{ userInitials }}</div>
        <div class="user-name full-email">{{ userEmail }}</div>
        <div class="user-role">{{userRole | titlecase}}</div>
      </div>
    </div>
    <div class="user-menu" *ngIf="showUserMenu">
      <div class="menu-header">My Account</div>
      <div class="menu-item" (click)="goToSettings()">
        <i data-lucide="settings" class="nav-icon"></i>
        <span>Settings</span>
      </div>
      <div class="menu-item" (click)="logout()">
        <i data-lucide="log-out" class="nav-icon"></i>
        <span>Logout</span>
      </div>
    </div>
  </div>
</aside>